import { controllers } from 'chart.js'

class StateChangeController extends controllers.BarController {

    draw() {
        
        const { 
            ctx, 
            chartArea: {
                top, bottom, left, width
            },
            config: {
                options
            }
        } = this.chart
        
        const meta = this.getMeta()
        const data = meta.data

        const { labels, baseline } = this.chart.config.data

        if (baseline !== null){
            const baseline_val = labels.findIndex(el => el === baseline)

            const n = labels.length
            const h = Math.round(width/n)
            
            const baseline_x = left + h*(baseline_val+0.5)
            
            let rec_start = top
            for (let i=0; i<data.length; i++){
                            
                let rec_height = bottom - data[i].y
                let x_val = left + h*(i + 0.5)
                let rec_left = i < baseline_val ? x_val : baseline_x
                
                let rec_width = Math.abs(baseline_x - x_val)
    
                ctx.fillStyle = options.backgroundColor[n - 1 + i - baseline_val]            
                ctx.fillRect(rec_left, rec_start, rec_width, rec_height)
    
                rec_start = rec_start + rec_height
            }
    
            ctx.beginPath()
            ctx.moveTo(baseline_x, top)
            ctx.lineTo(baseline_x, bottom)
            ctx.strokeStyle = 'black'
            ctx.lineWidth = 2
            ctx.stroke()
        }

    }
}

StateChangeController.id = 'stateChange'
StateChangeController.defaults = controllers.BarController.defaults

export default StateChangeController